import { Check, Input } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import AlertWithIcon from "views/common/alertWithIcon";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import React from "react";
import type FuelTypeChangeViewModel from "viewModels/callCenter/search/charges/fuelTypeChangeRefundViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import RefundPaymentForm from "../refund/refundPaymentForm";

export const FuelTypeChangeForm: ViewComponent<FuelTypeChangeViewModel> = observer(({ vm }) => {
  return (
    <Form onSubmit={preventDefault(vm.onSave)}>
      {vm.paymentInformationRequired && vm.changeWithRefund && (
        <AlertWithIcon variant="info">{vm.translate("paymentInformationRequired")}</AlertWithIcon>
      )}
      {!vm.isAllowedToChangePaymentInformation && !vm.paymentInformationDenied && vm.changeWithRefund && (
        <AlertWithIcon variant="danger">{vm.translate("paymentInformationNotAllowedToChange")}</AlertWithIcon>
      )}
      <div className="mb-4">
        <>
          <Form.Row>
            <FormGroup as={Col} md={6} target={vm.item} property="fuelTypeId">
              <FormLabel required={true}>{vm.translateAttribute("fuelTypeChangeRequest", "fuelTypeId")}</FormLabel>
              <AdvancedSelect items={vm.fuelTypeOptions} />
            </FormGroup>
            <FormGroup as={Col} md={6} target={vm.item} property="emailAddress">
              <FormLabel>{vm.translateAttribute("fuelTypeChangeRequest", "emailAddress")}</FormLabel>
              <Input disabled={!!vm.chargeResponse.emailAddress} />
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col} md={6} target={vm} property="officialRecordId">
              <FormLabel required={true}>{vm.translateAttribute("customerRefundCandidateRequest", "officialRecordId")}</FormLabel>
              <Input errorMessage={vm.officialRecordIdError()} />
            </FormGroup>
            {vm.changeWithRefund && (
              <Form.Group as={Col} className="mt-6">
                <Check
                  custom
                  target={vm.item}
                  property="isWithoutRefundFee"
                  label={vm.translate("isWithoutRefundFee")}
                  type="checkbox"
                />
              </Form.Group>
            )}
          </Form.Row>
          {vm.paymentInformationOptional && vm.isAllowedToChangePaymentInformation && vm.changeWithRefund && (
            <Form.Group as={Col} md={6} className="pt-md-6">
              <Check custom target={vm} property="fillBankAccount" label={vm.translate("fillBankAccount")} type="checkbox" />
            </Form.Group>
          )}
        </>
        {vm.showPaymentInformation && vm.changeWithRefund && <RefundPaymentForm vm={vm} />}
      </div>
    </Form>
  );
});

export default FuelTypeChangeForm;
